import { useSyncExternalStore } from "react";

import {
  getPlayerStore,
  GlobalPlayerStoreState,
  PlayerType,
} from "../../model";

export const usePlayerStore = <T>(
  type: PlayerType,
  selector: (state: GlobalPlayerStoreState) => T,
): T => {
  const store = getPlayerStore(type);

  return useSyncExternalStore(
    store.subscribe,
    () => selector(store.get()),
    () => selector(store.get()),
  );
};
